export default __webpack_public_path__ + "static/media/buy-bandwidth.ff04f354.svg";